module.exports = __webpack_public_path__ + "static/media/slider_pic.10581d29.jpg";